import React, {useMemo} from "react"

import PropTypes from "prop-types"

import AlertButton from "../Alert/alertButton"
import Message from "../Message"

import "./messageComplementaire.scss"

const MessageComplementaire = ({
    buttonLabel,
    className = null,
    content = null,
    displayIcon = false,
    header = null,
    onClickButton = null,
    type,
}) => {
    const builtHeader = useMemo(
        () =>
            buttonLabel && !content ? (
                <div className="header flex-container">
                    {header}
                    <AlertButton label={buttonLabel} onClick={onClickButton} />
                </div>
            ) : (
                header
            ),
        [buttonLabel, header, onClickButton],
    )

    const builtContent = useMemo(
        () =>
            content && buttonLabel ? (
                <p>
                    <span>{content}</span>
                    <br />
                    <AlertButton label={buttonLabel} onClick={onClickButton} />
                </p>
            ) : (
                content
            ),
        [buttonLabel, content, onClickButton],
    )

    return (
        <Message
            className={className}
            content={builtContent}
            displayIcon={displayIcon}
            header={builtHeader}
            type={type}
        />
    )
}

MessageComplementaire.propTypes = {
    className: PropTypes.string,
    content: PropTypes.any,
    displayIcon: PropTypes.bool,
    header: PropTypes.string,
    onClickButton: PropTypes.func,
    type: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
}

export default MessageComplementaire
